import React, { useEffect } from "react";
import "../styles/basenotification.css";
import { stickyNotification } from "../utils/common";

const BaseNotification = ({ ctaText, notificationMessage, onClickCta, customStyle, ...props }) => {
  useEffect(() => {
    let notification = document.getElementById("verification-main-wrapper");
    let sticky = notification?.offsetHeight;
    window.onscroll = function () {
      stickyNotification(window, sticky, notification);
    };
  }, []);

  return (
    <div
      className="base-notice-container"
      data-testid="base-main-wrapper"
      id="base-main-wrapper"
      style={customStyle}
    >
      <div className="notice-text">
        <div className="notice-text-label">{notificationMessage}</div>
        {ctaText && (
          <button className="base-cta" onClick={onClickCta} data-testid="verify-cta">
            {ctaText}
          </button>
        )}
      </div>
      {props.closeNotification && (
        <div className="close-icon" onClick={props.closeNotification} data-testid="closeNotification">
          <span aria-hidden="true">&times;</span>
        </div>
      )}
    </div>
  );
};

export default BaseNotification;
